<template>
  <div>
    <keep-alive>
      <component :is="coms" :cutcoms="cutcoms"></component>
    </keep-alive>
  </div>
</template>

<script>
export default {
  data() {
    return {
      //  isloading:false,
      isedit: "", //题库
      isActive: 0,
      currentRow: {},
      textOne: "", // 一级名称
      bankName: "", // 二级名称
      TestID: "",
      isselectitems: {}, //当前选中的sss
      isselectitemschilds: "", //当前选中的子节点数据。
      islooktestid: "", //当前查看的试卷的ID
      islooktestname: "", //当前查看的试卷名字
    };
  },
  components: {
    CertifiedHosp: () => import("./components/page.vue"),
    TheApproved: () => import("./components/addView.vue"),
    //  TheEditor: () => import("./components/detailTree.vue"),
    Encryption: () => import("./components/Protect.vue"),
    testsope: () => import("./components/testcope.vue"),
    // DecryTable: () => import("./components/encryption/decryTable.vue"),
    // ModifyThe: () => import("../../layout/components/userCenter/index.vue"),
  },
  computed: {
    coms() {
      switch (this.isActive) {
        case 0:
          return "CertifiedHosp";
        case 1:
          return "TheApproved";
        case 3:
          return "Encryption";
        case 4:
          return "testsope";
      }
      return "ss";
    },
  },
  methods: {
    cutcoms(index) {
      if (index == "0" && this.isActive == "1") {
        //这里代表新增返回
        this.$children[0].Buriedpoint({
          code: "QuestionBank:Custom:dirManage",
          parent_code: "QuestionBank:Custom",
        });
      }
      this.isActive = index;
    },
  },
};
</script>